var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEligetutarifa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "53px",
    viewBox: "0 0 76 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/negotiate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/negotiate",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1629594,23.9418197 C35.6150833,22.4921842 32.6021154,21.9236997 32.6021154,18.5980653 C32.6021154,16.2388546 34.6486597,13.9933408 38.5712028,13.9933408 C43.0906546,13.9933408 44.5402901,16.4946726 44.5402901,19.5076405 L49.940893,19.5076405 C49.940893,14.4197042 46.6152586,10.7245548 41.4136253,9.72970696 L41.4136253,3.7606196 L35.7287802,3.7606196 L35.7287802,9.75813118 C31.2377526,10.6677064 27.2015126,13.6522501 27.2015126,18.6264895 C27.2015126,25.0219403 32.2610247,26.5852727 38.5712028,28.6318169 C43.9149572,30.3656947 44.9666535,31.5879364 44.9666535,34.57248 C44.9666535,37.1306603 43.0622304,39.0066592 38.5712028,39.0066592 C35.1602957,39.0066592 32.175752,36.6190243 32.175752,33.1512688 L26.4909069,33.1512688 C26.4909069,38.4950232 30.4134501,42.2470209 35.7287802,43.270293 L35.7287802,49.2393804 L41.4136253,49.2393804 L41.4136253,43.3555657 C47.2121673,42.5312632 50.5093775,39.1203561 50.5093775,34.5440558 C50.5093775,29.2287256 47.8375003,26.3863031 40.1629594,23.9418197 L40.1629594,23.9418197 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(65.117141, 26.500000) rotate(-90.000000) translate(-65.117141, -26.500000) ",
    points: "59.2702352 33.7435348 66.4979889 26.5 59.2702352 19.2564652 61.4953733 17.0313271 70.9640462 26.5 61.4953733 35.9686729"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#FFFFFF",
    transform: "translate(11.883144, 26.500000) rotate(-270.000000) translate(-11.883144, -26.500000) ",
    points: "6.0362382 33.7435348 13.2639919 26.5 6.0362382 19.2564652 8.26137634 17.0313271 17.7300492 26.5 8.26137634 35.9686729"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEligetutarifa);
export default __webpack_public_path__ + "static/media/icon_eligetutarifa.06100365c1ad6dd30993b71ca31ddb8a.svg";
export { ForwardRef as ReactComponent };